export enum AttachmentType {
  Doc,
  Img,
}
